import { SWReactIcons } from "@similarweb/icons";
import { Tooltip } from "@similarweb/ui-components";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { StyledInfoIconWrapper } from "./styles";

interface IInfoTooltipProps {
    tooltipKey?: string;
    tooltipContent?: string;
}

const InfoIconTooltip = ({ tooltipKey, tooltipContent }: IInfoTooltipProps) => {
    return (
        <Tooltip
            placement="top"
            content={
                tooltipKey ? (
                    <I18n
                        translatable={{
                            key: tooltipKey,
                        }}
                    />
                ) : (
                    tooltipContent
                )
            }
        >
            <StyledInfoIconWrapper>
                <SWReactIcons
                    iconName="info"
                    size="xs"
                />
            </StyledInfoIconWrapper>
        </Tooltip>
    );
};

export default InfoIconTooltip;
